import React, { useEffect, useState, useRef } from 'react';
import AxiosInstance from '../AxiosInstance';
import Layout from './Layout';
import '../../stylesheet.css';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../ToastNotification';
import { dashboardMenuConfig } from "../menuconfig"; 

const AdminDashboard = () => {
  const navigate = useNavigate(); 
  const toastRef = useRef();

  const [employeeCount, setEmployeeCount] = useState(0);
  const [projectCount, setProjectCount] = useState(0);
  const [pendingLeaves, setPendingLeaves] = useState(0);
  const [pendingTimesheets, setPendingTimesheets] = useState(0);

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (dashboardMenuConfig.employeeCount) {
        try {
          const empRes = await AxiosInstance.get('/admin/employeeCount');
          setEmployeeCount(empRes.data.totalEmployees);
        } catch {
          toastRef.current?.showToast("Couldn't fetch employee count.", "danger");
        }
      }

      if (dashboardMenuConfig.projectCount) {
        try {
          const projRes = await AxiosInstance.get('/admin/projectCount');
          setProjectCount(projRes.data.totalProjects);
        } catch {
          toastRef.current?.showToast("Couldn't fetch project count.", "danger");
        }
      }

      if (dashboardMenuConfig.pendingLeaves) {
        try {
          const leaveRes = await AxiosInstance.get('/admin/pending-leaves');
          setPendingLeaves(leaveRes.data.pendingLeaves);
        } catch {
          toastRef.current?.showToast("Couldn't fetch pending leave requests.", "danger");
        }
      }

      if (dashboardMenuConfig.pendingTimesheets) {
        try {
          const timesheetRes = await AxiosInstance.get('/admin/pending-timesheets');
          setPendingTimesheets(timesheetRes.data.pendingTimesheets);
        } catch {
          toastRef.current?.showToast("Couldn't fetch pending timesheet data.", "danger");
        }
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <Layout heading="Dashboard">
      <div className="container">
        <div className="row">
          {dashboardMenuConfig.employeeCount && (
            <div className="dashboard-card card-emp col-sm-12 col-lg col-md-12 m-2">
              <h4>Current Employees</h4>
              <p>{employeeCount}</p>
            </div>
          )}
          {dashboardMenuConfig.projectCount && (
            <div className="dashboard-card card-proj col-sm-12 col-lg col-md-12 m-2">
              <h4>Total Projects</h4>
              <p>{projectCount}</p>
            </div>
          )}
          {dashboardMenuConfig.pendingLeaves && (
            <div className="dashboard-card card-leave col-sm-12 col-lg col-md-12 m-2">
              <h4>Pending Leave Requests</h4>
              <p>{pendingLeaves}</p>
            </div>
          )}
          {dashboardMenuConfig.pendingTimesheets && (
            <div className="dashboard-card card-timesheet col-sm-12 col-lg col-md-12 m-2">
              <h4>Pending Timesheet Requests</h4>
              <p>{pendingTimesheets}</p>
            </div>
          )}
          {dashboardMenuConfig.timesheetDefaulters && (
            <div
              className="dashboard-card card-defaulters col-sm-12 col-lg col-md-12 m-2"
              onClick={() => navigate("/timesheet-defaulters")}
              style={{ cursor: "pointer" }}
            >
              <h4>Timesheet Defaulters</h4>
            </div>
          )}
        </div>
      </div>
      <ToastNotification ref={toastRef} />
    </Layout>
  );
};

export default AdminDashboard;
